module.exports = __webpack_public_path__ + "img/primary.68d2339.svg";